import {cx} from "@emotion/css";

import {designColors} from "~/ui";
import {ReactComponent as SvgLock} from "~/assets/svg/lock.svg";

import {simpleIconStyles} from "../styles";
import {commonStyles} from "../../_common/styles";
import {IIconBase} from "../../_common/types";

export const BmLockIcon: React.FC<IIconBase> = ({id, size = "sm", color = designColors.black, className}) => {
  return <SvgLock id={id} className={cx(simpleIconStyles(size), commonStyles.color(color), className)} />;
};
